module.exports = __webpack_public_path__ + "8c5de328dd7d502c1453d526e5fe0038.png";